import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import "../css/navbar.css"; // Import the CSS file for styling

function Navbar() {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    document.cookie = `lang=${lang}; path=/; max-age=31536000`;
  };

  const contactLink = i18n.language === "lt" ? "/kontaktai" : "/contacts";

  return (
    <nav className="navbar navbar-expand-lg navbar-dark"
     role="navigation"
     aria-label="Main site navigation">
      <div className="container">
        <a className="navbar-brand m-0 h1" href="/">
          Priekabų Nuoma
        </a>

        <div
          id="language"
          className="d-flex ms-auto align-items-center text-center d-lg-none"
        >
          <div
            id="language"
            className="dropdown d-flex ms-auto align-items-center text-center d-lg-none"
            aria-label="Language selector"
             role="navigation"
             data-nosnippet>
            <button
              className="btn btn-outline-light dropdown-toggle"
              type="button"
              id="languageDropdown"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <img
                src={`/assets/flags/${i18n.language}.png`}
                alt={i18n.language.toUpperCase()}
                width="20"
                height="13"
                className="flag-shadow"
              />
              {i18n.language.toUpperCase()}
            </button>
            <ul
              className="dropdown-menu custom-dropdown-menu"
              aria-labelledby="languageDropdown"
            >
              <li>
                <button
                  className="dropdown-item btn btn-outline-light d-flex align-items-center justify-content-center"
                  onClick={() => changeLanguage("lt")}
                >
                  <img
                    src="/assets/flags/lt.png"
                    alt="LT"
                    width="20"
                    height="13"
                    className="flag-shadow-dropdown"
                  />
                  <span className="ms-2 flex-grow-1 text-end">LT</span>
                </button>
              </li>
              <li>
                <button
                  className="dropdown-item btn btn-outline-light d-flex align-items-center justify-content-center"
                  onClick={() => changeLanguage("en")}
                >
                  <img
                    src="/assets/flags/en.png"
                    alt="EN"
                    width="20"
                    height="13"
                    className="flag-shadow-dropdown"
                  />
                  <span className="ms-2 flex-grow-1 text-end">EN</span>
                </button>
              </li>
              <li>
                <button
                  className="dropdown-item btn btn-outline-light d-flex align-items-center justify-content-center"
                  onClick={() => changeLanguage("ru")}
                >
                  <img
                    src="/assets/flags/ru.png"
                    alt="RU"
                    width="20"
                    height="13"
                    className="flag-shadow-dropdown"
                  />
                  <span className="ms-2 flex-grow-1 text-end">RU</span>
                </button>
              </li>
            </ul>
          </div>
        </div>

        <button
          className="navbar-toggler ms-2"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse ms-lg-5" id="navbarNav">
          <ul className="navbar-nav">
            <li className="nav-item">
              <NavLink className="nav-link" to="/" end>
                {t("navbar.trailers")}
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to={contactLink} end>
                {t("navbar.contacts")}
              </NavLink>
            </li>
          </ul>
          <div
            id="language-lg"
            className="dropdown d-none d-lg-flex align-items-center ms-auto"
            aria-label="Language selector"
            role="navigation"
            data-nosnippet>
            <button
              className="btn btn-outline-light dropdown-toggle d-flex align-items-center gap-2"
              type="button"
              id="languageDropdown-lg"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <img
                src={`/assets/flags/${i18n.language}.png`}
                alt={i18n.language.toUpperCase()}
                width="20"
                height="13"
                className="flag-shadow"
              />
              {i18n.language.toUpperCase()}
            </button>
            <ul
              className="dropdown-menu custom-dropdown-menu"
              aria-labelledby="languageDropdown-lg"
            >
              <li>
                <button
                  className="dropdown-item btn btn-outline-light d-flex align-items-center justify-content-center"
                  onClick={() => changeLanguage("lt")}
                >
                  <img
                    src="/assets/flags/lt.png"
                    alt="LT"
                    width="20"
                    height="13"
                    className="flag-shadow-dropdown"
                  />
                  <span className="ms-2 flex-grow-1 text-end">LT</span>
                </button>
              </li>
              <li>
                <button
                  className="dropdown-item btn btn-outline-light d-flex align-items-center justify-content-center"
                  onClick={() => changeLanguage("en")}
                >
                  <img
                    src="/assets/flags/en.png"
                    alt="EN"
                    width="20"
                    height="13"
                    className="flag-shadow-dropdown"
                  />
                  <span className="ms-2 flex-grow-1 text-end">EN</span>
                </button>
              </li>
              <li>
                <button
                  className="dropdown-item btn btn-outline-light d-flex align-items-center justify-content-center"
                  onClick={() => changeLanguage("ru")}
                >
                  <img
                    src="/assets/flags/ru.png"
                    alt="RU"
                    width="20"
                    height="13"
                    className="flag-shadow-dropdown"
                  />
                  <span className="ms-2 flex-grow-1 text-end">RU</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
